var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimWifi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 13.954064 41.43512 C 14.558661 42.080021 15.526015 42.080021 16.170918 41.394814 C 23.950161 33.131992 34.14769 28.819206 45.554409 28.819206 C 57.041744 28.819206 67.27948 33.172298 75.058624 41.43512 C 75.62291 42.039715 76.550056 41.999409 77.194862 41.354507 L 81.709282 36.880493 C 82.273575 36.275894 82.23317 35.550381 81.789795 34.986088 C 74.373512 25.796219 60.387077 18.94413 45.554409 18.94413 C 30.761848 18.94413 16.775616 25.796219 9.318824 34.986088 C 8.875453 35.550381 8.875453 36.275894 9.439743 36.880493 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 27.053656 54.615322 C 27.738865 55.340839 28.666014 55.219921 29.351122 54.494404 C 33.059315 50.302536 39.185894 47.239246 45.554409 47.279552 C 52.003441 47.239246 58.089611 50.423454 61.918823 54.615322 C 62.523418 55.300533 63.369854 55.260227 64.095367 54.575016 L 69.133575 49.617325 C 69.657661 49.093342 69.697868 48.327518 69.254593 47.722923 C 64.417725 41.87849 55.590714 37.36417 45.554409 37.36417 C 35.518108 37.36417 26.690998 41.87849 21.894432 47.722923 C 21.410755 48.327518 21.410755 49.01273 22.01535 49.617325 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.5,
    d: "M 45.554409 71.826172 C 46.320232 71.826172 46.924728 71.503723 48.214535 70.254219 L 55.993675 62.797531 C 56.477455 62.31385 56.598373 61.507725 56.155003 60.943436 C 54.018761 58.202595 50.108936 55.824516 45.554409 55.824516 C 40.838558 55.824516 36.928734 58.323517 34.832897 61.185272 C 34.510345 61.668949 34.671673 62.31385 35.195557 62.797531 L 42.894085 70.254219 C 44.183891 71.463409 44.828793 71.826172 45.554409 71.826172 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimWifi);
export default __webpack_public_path__ + "static/media/sim-wifi.99f9f70629f1a5b760de1ce93650fcaa.svg";
export { ForwardRef as ReactComponent };